import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import logo from '../assets/logo.svg'; 

const Spinner = () => {
  const [showSpinner, setShowSpinner] = useState(true);
  const location = useLocation();  

  useEffect(() => {
   
    if (location.pathname === '/') {
      setShowSpinner(true);
      document.body.classList.add('spinner-active');

      const timer = setTimeout(() => {
        setShowSpinner(false); 
        document.body.classList.remove('spinner-active');
      }, 1000); // Hide spinner after 2 seconds

      return () => {
        clearTimeout(timer);
        document.body.classList.remove('spinner-active');
      };
    } else {
      setShowSpinner(false); 
    }
  }, [location.pathname]);  

  if (!showSpinner) return null;  

  return (
    <div className="spinner-overlay">
      <div className="spinner-container">
        <img src={logo} alt="Logo" className="logo-spinner" />
      </div>
    </div>
  );
};

export default Spinner;
